var map = {
	"./logo-agoric.webp": 17458,
	"./logo-aib.webp": 33200,
	"./logo-alter.webp": 9179,
	"./logo-andromeda.webp": 12090,
	"./logo-architech.webp": 67600,
	"./logo-archway.webp": 50760,
	"./logo-axelar.webp": 782,
	"./logo-bitcanna.webp": 43443,
	"./logo-bonus-block.webp": 68197,
	"./logo-crypto-chemistry.webp": 11267,
	"./logo-cudos.webp": 28051,
	"./logo-decentr.webp": 34011,
	"./logo-empowerchain.webp": 32293,
	"./logo-gravity-bridge.webp": 15882,
	"./logo-inter-protocol.webp": 61689,
	"./logo-jackal.webp": 93762,
	"./logo-kado.webp": 41310,
	"./logo-kelepar.webp": 85746,
	"./logo-kusama-kingdom.webp": 76071,
	"./logo-landslide.webp": 59765,
	"./logo-liquid-finance.webp": 54629,
	"./logo-living-opera.webp": 44496,
	"./logo-luckyfriday.webp": 89009,
	"./logo-nibiru.webp": 31741,
	"./logo-phi-labs.webp": 37913,
	"./logo-qwoyn-studios.webp": 84827,
	"./logo-silvermine-capital.webp": 19521,
	"./logo-sky-consulting.webp": 959,
	"./logo-synaps.webp": 73622,
	"./logo-vidulum.webp": 33507,
	"./logo-xavier-capital.webp": 50565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88330;